function inputMode() {
  if (typeof window === "undefined" || typeof navigator === "undefined") return "unknown";
  const touch = Number(navigator.maxTouchPoints || 0) > 0 || window.matchMedia?.("(pointer: coarse)").matches === true;
  const pointer = window.matchMedia?.("(pointer: fine)").matches === true;
  if (touch && pointer) return "mixed";
  if (touch) return "touch";
  if (pointer) return "pointer";
  return "unknown";
}

function positiveDimension(value: number | undefined) {
  return Number.isFinite(value) && Number(value) >= 1 && Number(value) <= 100000
    ? String(Math.round(Number(value)))
    : null;
}

export function addClientContextHeaders(headers: Headers) {
  if (typeof window === "undefined") return headers;
  const values: Array<[string, string | null]> = [
    ["x-truth-viewport-width", positiveDimension(window.innerWidth)],
    ["x-truth-viewport-height", positiveDimension(window.innerHeight)],
    ["x-truth-screen-width", positiveDimension(window.screen?.width)],
    ["x-truth-screen-height", positiveDimension(window.screen?.height)],
    ["x-truth-input-mode", inputMode()]
  ];
  for (const [name, value] of values) {
    if (value) headers.set(name, value);
  }
  return headers;
}
